import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";

// Normalize slugs for comparison: the legacy Brevo lists use underscores
// (the_backchannel) while editorial-newsletter rows use hyphens
// (the-backchannel). Match either convention so the widget works pre- and
// post-beehiiv-switchover.
const slugMatch = (a, b) => (a ?? "").replace(/[-_]/g, "-") === (b ?? "").replace(/[-_]/g, "-");


export class NewsletterInTOCBig extends Widget {
	componentWillMount() {
		this.handleEmail = this.handleEmail.bind(this);
		this.handleCheckbox = this.handleCheckbox.bind(this);
		if (
			this.props.category !== "morning-memo" &&
			this.props.category !== "where-things-stand"
		) {
			this.getData();
		}
		this.state.hidden = true;
		console.log(this.props);
	}

	componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		const addToMultipleLists = urlParams.get("addToMultipleLists");
		if (addToMultipleLists) {
			this.postData({ addToMultipleLists });
		}
	}

	clearErrors() {
		this.setState({ errors: null });
	}

	getData() {
		this.request("GET");
	}

	postData(opts) {
		this.clearErrors();
		this.request("POST", opts);
	}

	request(method, data = {}) {
		const self = this;

		let params = `?`;
		Object.keys(data).forEach((k) => {
			params += `${k}=${data[k]}&`;
		});

		fetch(
			`https://accounts.${document.location.hostname}/doesspress/email-list${params}`,
			{
				method: `${method}`,
				credentials: "include",
			}
		)
			.then((r) => {
				return r.json();
			})
			.then((r) => {
				if (method === "GET") {
					// console.log(r.bindings);
					self.setState(
						{
							emailLists: r.bindings.emailLists,
							ident: r.bindings.ident,
						},
						() => {
							// console.log(self.state);
						}
					);
				} else {
					if (r.errors) {
						self.setState({ error: r.errors[0] });
					}
					if (r.confirmation) {
						/* 
            if the user has just signed in and has an addToMultipleLists query param, we want to refresh the page
            after the email prefs are updated.

            this is hacky and dumb, but it lets us not worry about re-rending the form UI in response to ajax requests.
            if this form gets any more complex, change this and refactor how the doesspress/email-list endpoint works
             */
						if (
							r.confirmation.key !== "list_pref_create_account" &&
							data.addToMultipleLists
						) {
							window.location =
								window.location.origin + window.location.pathname;
						}
						self.setState({ confirmation: r.confirmation });
					}
				}
			});
	}

	handleCheckbox(e) {
		const signedIn = this.state.ident.id;
		if (!signedIn) return;

		const opts = {
			listId: document.querySelector(
				'.js_newsletter-listId'
			).value,
		};
		//always set opts.addToList = true, this form never unsubs anyone
		opts.addToList = true;

		this.postData(opts);
	}

	handleEmail(e) {
		e.preventDefault();
		debugger;

		const checkedInputs = document.querySelectorAll(
			".js_newsletter-checkbox:checked"
		);
		if (checkedInputs.length === 0) {
			this.setState({
				error: { message: "Please select a newsletter to subscribe to" },
			});
			return;
		} else {
			this.setState({
				error: null,
			});
		}

		const listIds = Array.from(checkedInputs).map(
			(input) =>
				document.querySelector(
					'.NewsletterInTOCBig__Form input[name="listId"]'
				).value
		);

		const opts = {
			addToMultipleLists: listIds.join(","),
			email: document.querySelector("#newEmail").value,
			nextPath: window.location.pathname,
		};

		console.log(opts);

		this.postData(opts);
	}

	listDescription(list) {
		if (slugMatch(list.slug, "the_weekender")) {
			return (
				<div>
					<p className="medium">Subscribe to The Weekender Newsletter</p>
					<p>Unpack the funny, surreal, and strange in U.S. politics and culture with Allegra Kirkland, Derick Dirmaier and the TPM team.</p>
				</div>
			);
		}

		if (slugMatch(list.slug, "the_franchise")) {
			return (
				<div>
					<p className="medium">Subscribe to The Franchise Newsletter</p>
					<p>What you need to know about the assault on voting rights and democracy in America, brought to you
					weekly by TPM reporter Khaya Himmelman.</p>
				</div>
			);
		}

		if (slugMatch(list.slug, "the_backchannel")) {
			if (this.props.membership && this.props.membership === "1")
				return (
					<div>
						<p className="medium">Subscribe to The Backchannel Newsletter</p>

						<p>Josh Marshall's direct
						line for insight, analysis, and conversation. TPM members receive
						one must-read daily.</p>
					</div>
				);

			return (
				<div>
					<p className="medium">Subscribe to The Backchannel Newsletter</p>
					<p>Josh Marshall's direct line for insight, analysis, and conversation. Non-members can subscribe to
					the free edition and receive one must-read from Josh weekly.</p>
				</div>
			);
		}

		return "";
	}

	renderNotYetSubscribed(list) {
		if (list.subscribed) return this.renderButton(true);
 
		if (this.state.confirmation && this.state.hidden) return;

		if (this.state.confirmation) {
			return (
				<div className={`NewsletterInTOCBig__Inner`}>
					<div className={`NewsletterInTOCBig__Column --center`}>
						<div className="NewsletterInTOCBig__Hide" onClick={() => this.setState({ hidden: true })}>
							<Icon name="xmark" style="light" />
						</div>
						<p className="big">You’re Subscribed!</p>
						<p>Manage your subscription in the{' '}
							<a
								href="https://accounts.talkingpointsmemo.com/account#email"
								target="_blank"
								className="NewsletterInTOCBig__Link"
							>
								account&nbsp;panel&nbsp;<Icon name="arrow-right-long" style="light" />
							</a>
						</p>
					</div>
				</div>
			);
		}

		return (
			<div>
				<input className="js_newsletter-listId" type="hidden" name="listId" value={list.id} />
				<span
					className="NewsletterInTOCBig__Show"
					onClick={this.handleCheckbox}
				>
					Subscribe <Icon name="plus" style="light" />
				</span>
			</div>
		);
	}

	renderMorningMemo() {
		if (this.state.hidden) return this.renderButton();
		return (
			<div className={`NewsletterInTOCBig__Inner`}>
				<div className={`NewsletterInTOCBig__Column --top`}>
					<div className="NewsletterInTOCBig__Hide" onClick={() => this.setState({ hidden: true })}>
						<Icon name="xmark" style="light" />
					</div>
					<p>Morning Memo subscriptions are managed through Substack. </p>
					<a
						href="https://morningmemo.talkingpointsmemo.com/"
						target="_blank"
						className="NewsletterInTOCBig__Link"
					>
						Manage subscription preferences&nbsp;<Icon name="arrow-right-long" style="light" />
					</a>
				</div>
			</div>
		);
	}

	renderWhereThingsStand() {
		if (this.state.hidden) return this.renderButton();
		return (
			<div className={`NewsletterInTOCBig__Inner`}>
				<div className={`NewsletterInTOCBig__Column --top`}>
					<div className="NewsletterInTOCBig__Hide" onClick={() => this.setState({ hidden: true })}>
						<Icon name="xmark" style="light" />
					</div>
					<p>Where Things Stand subscriptions are managed through Substack.</p>
					<a
						href="https://wherethingsstand.talkingpointsmemo.com/"
						target="_blank"
						className="NewsletterInTOCBig__Link"
					>
						Manage subscription preferences&nbsp;<Icon name="arrow-right-long" style="light" />
					</a>
				</div>
			</div>
		);
	}

	renderAlreadySubscribed() {
		if (this.state.hidden) return this.renderButton(true);
		return (
			<div className={`NewsletterInTOCBig__Inner`}>
				<div className={`NewsletterInTOCBig__Column --center`}>
					<div className="NewsletterInTOCBig__Hide" onClick={() => this.setState({ hidden: true })}>
						<Icon name="xmark" style="light" />
					</div>
					<p className="big">You’re Subscribed!</p>
					<p>Manage your subscription in the{' '}
						<a
							href="https://accounts.talkingpointsmemo.com/account#email"
							target="_blank"
							className="NewsletterInTOCBig__Link"
						>
							account&nbsp;panel&nbsp;<Icon name="arrow-right-long" style="light" />
						</a>
					</p>
				</div>
			</div>
		);
	}	

	renderEmailForm(list) {
		if (this.state.hidden) return this.renderButton(list.subscribed);
		const confirmAcctCreation = this.state.confirmation;
		return (
			<div className={`NewsletterInTOCBig__Inner`}>
				<div className={`NewsletterInTOCBig__Column`}>
					<div className="NewsletterInTOCBig__Hide" onClick={() => this.setState({ hidden: true })}>
						<Icon name="xmark" style="light" />
					</div>
			
					{!confirmAcctCreation && this.renderEmailFormInner(list)}

					{confirmAcctCreation && (
						<div className="NewsletterInTOCBig__Confirmation">
							<h4>Check your inbox!</h4>
							<p>{this.state.confirmation.message}</p>
							<p>
								Don’t see an email? Please check your spam folder or{" "}
								<a href="https://talkingpointsmemo.com/contact">
									contact&nbsp;us
								</a>{" "}
								for assistance.
							</p>
						</div>
					)}


					{this.state.error && (
						<p
							style={{
								background: "#ffefb0",
								padding: "10px",
							}}
						>
							{this.state.error.message}
						</p>
					)}
				</div>
			</div>
		);
	}

	renderEmailFormInner(list) {
		return (
			<div className="NewsletterInTOCBig__Form">
				<input type="hidden" name="listId" value={list.id} />
				<input
					className=" js_newsletter-checkbox"
					id={`id_${list.id}`}
					name="addToList"
					type="checkbox"
					defaultChecked={true}
					style={{ display: "none" }}
				/>
				<div className="NewsletterInTOCBig__Description">
					{this.listDescription(list)}
				</div>
				<div className="NewsletterInTOCBig__Flex">
					<label
						htmlFor={`id_${list.id}`}
						style={{
							position: "absolute",
							width: "1px",
							height: "1px",
							padding: 0,
							margin: "-1px",
							overflow: "hidden",
							clip: "rect(0,0,0,0)",
							border: 0,
						}}
					>
						Email Address
					</label>
					<input
						type="email"
						id="newEmail"
						pattern=".+@example\.com"
						required
						placeholder="Email Address"
					/>
					<div
						className="NewsletterInTOCBig__Button --min-w Button --transparent-to-red"
						onClick={this.handleEmail}
					>
						Subscribe
					</div>
				</div>
			</div>
		);
	}

	categoryToList(category) {
		const lists = this.state.emailLists;

		if (category === "the-weekender") {
			return lists.find((list) => slugMatch(list.slug, "the_weekender"));
		}

		if (category === "the-franchise") {
			return lists.find((list) => slugMatch(list.slug, "the_franchise"));
		}

		if (category === "the-backchannel") {
			return lists.find((list) => slugMatch(list.slug, "the_backchannel"));
		}
		return null;
	}

	renderButton(alreadySubscribed = false) {
		return (
			<div className="NewsletterInTOCBig__Show" onClick={() => this.setState({ hidden: false })}>
				{alreadySubscribed &&(<span>Subscribed <Icon name="check" style="regular" /></span>)}
				{!alreadySubscribed &&(<span>Subscribe <Icon name="plus" style="light" /></span>)}
			</div>
		)
	}

	/* 
	1. if morning-memo or where-things-stand, show those
	4. if signed in and subscribed, show manage subscription btn + panel (renderAlreadySubscribed)
	3. if singned in but not subscribed, show sub btn
	2. if not signed in, show email form
	 */

	renderContent() {
		/* 1 - substack catgories*/
		if (this.props.category === "morning-memo") {
			return this.renderMorningMemo();
		}

		if (this.props.category === "where-things-stand") {
			return this.renderWhereThingsStand();
		}


		if (
			!["the-weekender", "the-franchise", "the-backchannel"].includes(
				this.props.category
			)
		) {
			return;
		}


		if (this.state.error && !this.state.emailLists) return;
		if (!this.state.emailLists) return;

		/* 2 - signed in and already sub'd */
		const signedIn = this.state.ident.id;
		const theList = this.categoryToList(this.props.category);
		const alreadySubscribed = signedIn && theList && theList.subscribed;
		if (alreadySubscribed) return this.renderAlreadySubscribed();
		

		/* 3 - signed in but not sub'd */
		if (signedIn) return this.renderNotYetSubscribed(theList); 
		
		/* 4 - not signed in, email form */
		if (!signedIn) return this.renderEmailForm(theList); 
		
	}
}
